module.exports = "/_next/static/images/TankerS-0aa90541dc8d078c134c8244c74b8638.svg";